enum APPLICATION_PATHS {
  HOME = '/',
  MOVIE_LIST = '/movies',
  MOVIE_DETAIL = '/movies/detail/:id',
  NOT_FOUND = '*',
}

export default APPLICATION_PATHS
